/** API エラーがセッション切れ（401 等）かどうか */
export const isSessionExpiredError = (err) =>
  Boolean(
    err?.message &&
      (err.message.includes('401') || err.message.includes('Session'))
  );
